export default __webpack_public_path__ + "static/flag-d58f0c21563c6826e28b828ce8bc3177.png";